import React, {useState} from "react";
import {FormControlLabel } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./ManualScore.css";
import {makeStyles} from '@mui/styles';
import OrangeSwitch from "../../OrangeSwitch";

const useStyles = makeStyles((theme) => ({
    switchLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
}));


const ManualScoreAdditionalQuestions = ({updateScore, cvScore}) => {

    const switchLabelClasses = useStyles();

    const [additionalQuestionsScores, setAdditionalQuestionsScores] = useState(cvScore);

    const handleAdditionalQuestionsChange = (e) => {
        let { name, checked } = e.target;

        setAdditionalQuestionsScores((prevScore) => ({
            ...prevScore,
            [name]: (checked),
        }));

        updateScore("additionalQuestionsScore", { ...additionalQuestionsScores, [name]: checked})
    }

    return (
        <Box className={"scoringBox"} data-testid={"manualScoreBox"}>
            <Grid container padding={2} spacing={2}>
                <Grid item xs={12}>
                    <h3>
                        Additional Questions
                    </h3>
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={<OrangeSwitch/>}
                        style={{width:"100%", marginLeft:"0px"}}
                        onChange={(e) => {handleAdditionalQuestionsChange(e)}}
                        label="Willing to work hybrid"
                        checked={additionalQuestionsScores?.hybrid}
                        name={"hybrid"}
                        data-testid={"hybrid"}
                        classes={{label:switchLabelClasses.switchLabel}}
                        labelPlacement="start"
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={<OrangeSwitch/>}
                        style={{width:"100%", marginLeft:"0px"}}
                        label="Cities"
                        name={"cities"}
                        checked={additionalQuestionsScores?.cities}
                        data-testid={"cities"}
                        classes={{label:switchLabelClasses.switchLabel}}
                        onChange={(e) => {handleAdditionalQuestionsChange(e)}}
                        labelPlacement="start"
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={<OrangeSwitch/>}
                        style={{width:"100%", marginLeft:"0px"}}
                        label="Within expected salary band"
                        checked={additionalQuestionsScores?.salaryBand}
                        onChange={(e) => {handleAdditionalQuestionsChange(e)}}
                        classes={{label:switchLabelClasses.switchLabel}}
                        data-testid={"salaryBand"}
                        name={"salaryBand"}
                        labelPlacement="start"
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={<OrangeSwitch/>}
                        style={{width:"100%", marginLeft:"0px"}}
                        label="Does the notice period coincide with the required start date"
                        onChange={(e) => {handleAdditionalQuestionsChange(e)}}
                        classes={{label:switchLabelClasses.switchLabel}}
                        checked={additionalQuestionsScores?.noticePeriod}
                        labelPlacement="start"
                        data-testid={"noticePeriod"}
                        name={"noticePeriod"}
                    />
                </Grid>

                <Grid item xs={12}/>
            </Grid>
        </Box>
    )
}
export default ManualScoreAdditionalQuestions;